import { ArrowsPointingInIcon } from "@heroicons/react/24/outline";
import { ButtonBase } from "@repo/ui/index.tsx";
import React, { useState } from "react";

interface IChartContainerProps {
  children: React.ReactNode;
  as?: React.ElementType;
  className?: string;
  headingComp?: React.ReactNode;
  topRightActionComp?: React.ReactNode;
}

function ChartContainer({
  topRightActionComp = <></>,
  children,
  as,
  headingComp,
  className = "bg-white",
}: IChartContainerProps) {
  //STATES
  const [zoomed, setZoom] = useState(false);

  const Component = as || "div";
  return (
    <Component
      className={`ring-1 ring-extraLightGray bg-white  shadow-extraLightGray/80 rounded-lg px-4 py-2 ${className}`}
    >
      <section className="flex items-center justify-between py-1">
        {headingComp}

        <section className="flex items-center gap-2">
          {topRightActionComp}
        </section>
      </section>
      {children}
      {zoomed ? (
        <section className="fixed w-full h-screen top-0 left-0 z-50 flex items-center justify-center bg-extraLightGray/20 backdrop-blur-sm">
          <div className="h-[calc(100vh-50px)] bg-white p-6 rounded-lg w-11/12 shadow-lg shadow-gray">
            <section className="flex items-center justify-between py-1">
              {headingComp}
              <div>
                <ButtonBase
                  buttonType="tertiary"
                  icon={<ArrowsPointingInIcon className="size-5 text-body" />}
                  className=""
                  onClick={() => {
                    setZoom(!zoomed);
                  }}
                />
              </div>
            </section>
            {children}
          </div>
        </section>
      ) : (
        <></>
      )}
    </Component>
  );
}

export default ChartContainer;
